module.exports = __webpack_public_path__ + "static/media/27OCHA2.e35c70a7.jpg";